import { Dispatch } from 'redux';
import { getErrorJson } from '@mm/utils';
import { showFacebookConnectModal } from '../actions/networkActions';
import ConnectedPageCRUDActions from '../actions/ConnectedPageCRUDActions';
import CampaignsCRUDActions from '../actions/CampaignsCRUDActions';
import modalActions from '../modules/modalsState/actions';
import { permissionsHandler } from './common-handler';
import { StoreState } from '../store-interfaces';
import CrudActionContainer from '../actions/CrudActionContainer';

export const ALREADY_USED_TRIGGER_ERROR_TEXT =
  'trigger is already in use in other active automation';

export default (
    dispatch: Dispatch<StoreState>,
    container: CrudActionContainer,
  ) =>
  async error => {
    let errors = [];
    switch (error.status) {
      case 403:
        dispatch(
          showFacebookConnectModal(
            'Please give us permissions to your account',
            false,
            'ALL_PERMISSIONS',
          ),
        );
        dispatch(ConnectedPageCRUDActions.unbusy());
        break;
      case 422:
        errors = (await getErrorJson(error))?.errors;
        dispatch(ConnectedPageCRUDActions.unbusy());

        if (errors.length) {
          const message: string = errors[0];
          if (message.includes(ALREADY_USED_TRIGGER_ERROR_TEXT)) {
            return;
          }

          dispatch(
            modalActions.openGeneralTextModal({
              header: 'Ooops!',
              message: errors[0],
              closeButtonText: 'Close',
            }),
          );
        }

        dispatch({
          type: CampaignsCRUDActions.setErrorStatus,
          errorMessages: errors,
        });
        break;
      default:
        permissionsHandler(dispatch, container)(error);
    }
  };
